export enum ECommissionType {
  WithoutDeposit = 1,
  Exclusive = 2,
}
